import {
  saveUserImp,
  getAllUsersImp,
  getUserDataByIdImp,
  getProjectByIdImp,
  getProjectsImp,
  saveProjectImp,
  deleteProjectImp,
  uploadGlbFileImp,
  getInspectionByIdImp,
  saveInspectionImp,
  deleteInspectionImp,
  getInspectionsByUnitIdImp,
  deleteInspectionsByUnitIdImp,
  getTeamByNameImp,
  getAllTeamsImp,
  saveTeamImp,
  deleteTeamImp,
  getUnitByIdImp,
  getUnitsByProjectIdImp,
  getUnitsByBuildingIdImp,
  saveUnitImp,
  deleteUnitImp,
  deleteUnitsByProjectIdImp,
  saveUnitsImp,
  saveInspectionsImp,
  getMigrationVersionImp,
  saveMigrationVersionImp,
  saveActionItemImp,
  deleteActionItemImp,
  getActionItemImp,
  getActionsByProjectIdImp,
  getActionsByUnitIdImp,
  getActionItemPayloadImp,
  saveActionItemPayloadImp,
  findConsiderNewInspectionActionImp,
  findInspectionsByStatusImp,
  findCheckInOnInspectionProgressActionsImp,
  findActionItemsByUnitIdAndTitleImp,
  findActionItemsByUnitIdAndCategoryImp,
  findActionItemsByCategoryAndStatusImp,
  getActionItemsImp,
  getActionItemsByBuildingIdImp,
  getActionItemsByUnitIdImp,
  createNewInspectionImp,
  updateUnitImp,
  getActionsImp,
  uploadUnitAttachmentImp,
  uploadActionItemAttachmentImp,
  sendMessageImp,
  initialize as initalizeFirebase,
  FirebaseConfig,
  MigrationVersion,
  saveUserOAuthTokensImp,
  getUserOAuthTokensImp,
  deleteWebhookImp,
  getWebhookImp,
  saveWebhookImp,
  getWebhooksImp,
  createTaskNotificationRequestImp,
  getTaskNotificationRequestByTaskIdImp,
  getTaskNotificationRequestImp,
  findActionItemsByFiltersImp,
  subscribeActionsByProjectIdImp,
  subscribeActionsByUnitIdImp,
  saveFeedEventImp,
  getFeedEventImp,
  deleteFeedEventImp,
  feedEventsQueryImp,
  getItemsImp,
  subscribeToImp,
  getUserEmailSubscriptionsImp,
  saveUserEmailSubscriptionImp,
  getUserEmailSubscriptionByHistoryIdImp,
  deleteUserEmailSubscriptionImp,
  getUserEmailSubscriptionByIdImp,
  getBuildingWorkflowsImp,
  genericQueryImp,
  getDatabase,
  saveGenericObjectmImp,
  getGenericObjectImp,
  deleteGenericObjImp,
  getLeasesByUnitIdImp,
  getCurrentLeaseImp,
  getLeasesImp,
} from './firebase/firebase';

import {
  UserData,
  UserEmailSubscription,
  UserOAuthTokens,
  Project,
  Unit,
  Inspection,
  Team,
  ActionItem,
  ActionItemPayload,
  ActionItemCategory,
  ActionItemStatus,
  InspectionStatus,
  MessageTemplateType,
  TaskWebhook,
  TaskNotificationRequest,
  FeedEvent,
  BuildingWorkflow,
  Process,
  Lease,
} from '@urbanmix-tech/shared-js';
import { QueryFieldFilterConstraint, where } from 'firebase/firestore';
import { WithId } from './firebase/helpers';

export function initialize(firebaseConfig: FirebaseConfig): void {
  console.log('going to init');
  initalizeFirebase(firebaseConfig);
  console.log('initialized');
}

export const getActionItemPayload = async (
  id: string
): Promise<ActionItemPayload | null> => {
  return getActionItemPayloadImp(id);
};

export const saveActionItemPayload = async (
  actionItemPayloadToSave: ActionItemPayload
): Promise<string | null> => {
  return saveActionItemPayloadImp(actionItemPayloadToSave);
};

export const getActionItem = async (id: string): Promise<ActionItem | null> => {
  return getActionItemImp(id);
};

export const findConsiderNewInspectionAction = async (
  projectId: string,
  buildingId: number,
  unitId: string,
  updateDate: Date
): Promise<ActionItem[]> => {
  return findConsiderNewInspectionActionImp(
    projectId,
    buildingId,
    unitId,
    updateDate
  );
};

export const findActionItemsByUnitIdAndTitle = async (
  projectId: string,
  buildingId: number,
  unitId: string,
  title: string
): Promise<ActionItem[]> => {
  return findActionItemsByUnitIdAndTitleImp(
    projectId,
    buildingId,
    unitId,
    title
  );
};

export const findActionItemsByUnitIdAndCategory = async (
  projectId: string,
  buildingId: number,
  unitId: string,
  category: ActionItemCategory
): Promise<ActionItem[]> => {
  return findActionItemsByUnitIdAndCategoryImp(
    projectId,
    buildingId,
    unitId,
    category
  );
};

export const findActionItemsByCategoryAndStatus = async (
  projectId: string,
  buildingId: number,
  unitId: string,
  category: ActionItemCategory,
  status: ActionItemStatus[]
): Promise<ActionItem[]> => {
  return findActionItemsByCategoryAndStatusImp(
    projectId,
    buildingId,
    unitId,
    category,
    status
  );
};

export const findActionItemsByFilters = async (
  projectId?: string,
  buildingId?: number,
  unitId?: string,
  category?: ActionItemCategory,
  dueDate?: Date,
  owner_email?: string,
  supervisor_email?: string,
  follower_email?: string,
): Promise<ActionItem[]> => {
  return findActionItemsByFiltersImp(
    projectId,
    buildingId,
    unitId,
    category,
    dueDate,
    owner_email,
    supervisor_email,
    follower_email
  );
};

export const findCheckInOnInspectionProgressActions = async (
  projectId: string,
  buildingId: number,
  unitId: string
): Promise<ActionItem[]> => {
  return findCheckInOnInspectionProgressActionsImp(
    projectId,
    buildingId,
    unitId
  );
};

export const saveActionItem = async (
  actionItemToSave: ActionItem
): Promise<string | null> => {
  return saveActionItemImp(actionItemToSave);
};

export const deleteActionItem = async (id: string): Promise<boolean> => {
  return deleteActionItemImp(id);
};

export const getActionsByUnitId = async (
  projectId: string,
  buildingId: number,
  unitId: string
): Promise<ActionItem[]> => {
  return getActionsByUnitIdImp(projectId, buildingId, unitId);
};

export const getActionsByProjectId = async (
  projectId: string
): Promise<ActionItem[]> => {
  return getActionsByProjectIdImp(projectId);
};

export const subscribeActionsByProjectId = async (
  projectId: string,
  onUpdate: (actionItems: ActionItem[]) => void,
  onError: (error: Error) => void
): Promise<() => void> => {
  return subscribeActionsByProjectIdImp(projectId,onUpdate,onError);
};

export const subscribeActionsByUnitId = async (
  projectId: string,
  buildingId: number,
  unitId: string,
  onUpdate: (actionItems: ActionItem[]) => void,
  onError: (error: Error) => void
): Promise<() => void> => {
  return subscribeActionsByUnitIdImp(projectId, buildingId, unitId, onUpdate, onError);
};

export const getActions = async (): Promise<ActionItem[]> => {
  return getActionsImp();
};

export const getUserDataById = async (
  userId: string
): Promise<UserData | null> => {
  return getUserDataByIdImp(userId);
};

export async function saveUser(userToSave: UserData): Promise<string | null> {
  return saveUserImp(userToSave);
}

export const getAllUsers = async (): Promise<UserData[] | null> => {
  console.log('getting all users');
  return getAllUsersImp();
};

export const getTeamByName = async (name: string): Promise<Team | null> => {
  return getTeamByNameImp(name);
};

export const getAllTeams = async (limits?: number): Promise<Team[] | null> => {
  return getAllTeamsImp(limits);
};

export const saveTeam = async (teamToSave: Team): Promise<string | null> => {
  return saveTeamImp(teamToSave);
};

export const deleteTeam = async (name: string): Promise<boolean> => {
  return deleteTeamImp(name);
};

export const saveUserOAuthToken = async (
  token: UserOAuthTokens
): Promise<string | null> => {
  return saveUserOAuthTokensImp(token);
};

export const getUserOAuthToken = async (
  userId: string
): Promise<UserOAuthTokens[] | null> => {
  return getUserOAuthTokensImp(userId);
};

export const saveUserEmailSubscription = async (
  subscription: UserEmailSubscription
): Promise<string | null> => {
  return saveUserEmailSubscriptionImp(subscription);
};

export const getUserEmailSubscriptionById = async (id: string): Promise<UserEmailSubscription | null> => {
  return getUserEmailSubscriptionByIdImp(id);
};


export const getUserEmailSubscriptions = async (
  userId: string
): Promise<UserEmailSubscription[] | null> => {
  return getUserEmailSubscriptionsImp(userId);
};

export const deleteUserEmailSubscription = async (
  userId?: string,
  service?: string,
  id?: string
) : Promise<void> => {
  return deleteUserEmailSubscriptionImp(userId,service,id);
}

export const getUserEmailSubscriptionHistoryId = async (
  historyId: string
): Promise<UserEmailSubscription | null> => {
  return getUserEmailSubscriptionByHistoryIdImp(historyId);
};

export const getUserEmailSubscription = async (
  userId: string,service: string
): Promise<UserEmailSubscription | null> => {

  return getUserEmailSubscriptionsImp(userId).then((subscriptions) => {
    return subscriptions?.find((subscription) => subscription.service === service) || null;
  }  
)};

export const getInspectionById = async (
  projectId: string,
  unitId: string,
  inspectionId: string
): Promise<Inspection | null> => {
  return getInspectionByIdImp(projectId, unitId, inspectionId);
};

export const findScheduledInspection = async (
  projectId: string,
  unitId: string
): Promise<Inspection | null> => {
  const inspections = await findInspectionsByStatusImp(
    projectId,
    unitId,
    InspectionStatus.Scheduled
  );

  if (inspections.length > 0) {
    return inspections[0];
  }

  return null;
};

export const findDraftInspections = async (
  projectId: string,
  unitId: string
): Promise<Inspection[]> => {
  return findInspectionsByStatusImp(projectId, unitId, InspectionStatus.Draft);
};

export const createNewInspection = async (
  projectId: string,
  unitId: string,
  inspectionToSave: Inspection
): Promise<string | null> => {
  return createNewInspectionImp(projectId, unitId, inspectionToSave);
};

export const saveInspection = async (
  projectId: string,
  unitId: string,
  inspectionToSave: Inspection
): Promise<string | null> => {
  return saveInspectionImp(projectId, unitId, inspectionToSave);
};

export const saveInspections = async (
  projectId: string,
  unitId: string,
  inspections: Inspection[]
): Promise<boolean> => {
  return saveInspectionsImp(projectId, unitId, inspections);
};

export const deleteInspection = async (
  projectId: string,
  unitId: string,
  inspectionId: string
): Promise<boolean> => {
  return deleteInspectionImp(projectId, unitId, inspectionId);
};

export const getInspectionsByUnitId = async (
  projectId: string,
  unitId: string
): Promise<Inspection[]> => {
  return getInspectionsByUnitIdImp(projectId, unitId);
};

export const deleteInspectionsByUnitId = async (
  projectId: string,
  unitId: string
): Promise<boolean> => {
  return deleteInspectionsByUnitIdImp(projectId, unitId);
};

export const getUnitById = async (
  projectId: string,
  unitId: string
): Promise<Unit | null> => {
  return getUnitByIdImp(projectId, unitId);
};

export const updateUnit = async (
  projectId: string,
  unitId: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateData: Record<string, any>
): Promise<void> => {
  return updateUnitImp(projectId, unitId, updateData);
};

export const saveUnit = async (
  projectId: string,
  unitToSave: Unit
): Promise<string | null> => {
  return saveUnitImp(projectId, unitToSave);
};

export const saveUnits = async (
  projectId: string,
  units: Unit[]
): Promise<boolean> => {
  return saveUnitsImp(projectId, units);
};

export const deleteUnit = async (
  projectId: string,
  unitId: string
): Promise<boolean> => {
  return deleteUnitImp(projectId, unitId);
};

export const getUnitsByProjectId = async (
  projectId: string
): Promise<Unit[]> => {
  return getUnitsByProjectIdImp(projectId);
};

export const getUnitsByBuildingId = async (
  projectId: string,
  buildingId: number
): Promise<Unit[]> => {
  return getUnitsByBuildingIdImp(projectId, buildingId);
};

export const deleteUnitsByProjectId = async (
  projectId: string
): Promise<boolean> => {
  return deleteUnitsByProjectIdImp(projectId);
};

export const saveProject = async (
  projectToSave: Project
): Promise<string | null> => {
  return saveProjectImp(projectToSave);
};

export const getProjectById = async (
  projectId: string
): Promise<Project | null> => {
  return getProjectByIdImp(projectId);
};

export const getProjects = async (): Promise<Project[]> => {
  return getProjectsImp();
};

export const deleteProject = async (
  projectId: string,
  archive: boolean = false
): Promise<boolean> => {
  return deleteProjectImp(projectId, archive);
};

export const getMigrationVersion = async (): Promise<MigrationVersion | null> => {
  return getMigrationVersionImp();
};

export const saveMigrationVersion = async (
  migrationVersionToSave: MigrationVersion
): Promise<string | null> => {
  return saveMigrationVersionImp(migrationVersionToSave);
};

export const uploadGlbFile = (
  file: File,
  projectId: string,
  buildingId: string
): Promise<string | null> => {
  return uploadGlbFileImp(file, projectId, buildingId);
};

export const uploadUnitAttachment = (
  file: File,
  filename: string,
  projectId: string,
  buildingId: string
): Promise<string | null> => {
  return uploadUnitAttachmentImp(file, filename, projectId, buildingId);
};

export const uploadActionItemAttachment = (
  file: File,
  filename: string,
  projectId: string,
  buildingId: number,
  taskId: string
): Promise<string | null> => {
  return uploadActionItemAttachmentImp(file, filename, projectId, buildingId, taskId);
};

export const getActionItems = async (): Promise<ActionItem[]> => {
  return getActionItemsImp();
};

export const getActionItemsByBuildingId = async (
  projectId: string,
  buildingId: number
): Promise<ActionItem[]> => {
  return getActionItemsByBuildingIdImp(projectId, buildingId);
};

export const getActionItemsByUnitId = async (
  projectId: string,
  buildingId: number,
  unitId: string
): Promise<ActionItem[]> => {
  return getActionItemsByUnitIdImp(projectId, buildingId, unitId);
};

export const sendMessage = ({
  to,
  projectName,
  unitName,
  inspectorName,
  assignerName,
  scheduledDate,
  address,
  leaseEndDate,
  templateType,
}: {
  to: string;
  projectName: string;
  unitName: string;
  inspectorName: string;
  assignerName: string;
  scheduledDate: Date;
  address: string;
  leaseEndDate: Date | null;
  templateType: MessageTemplateType;
}) => {
  return sendMessageImp({
    to,
    projectName,
    unitName,
    inspectorName,
    assignerName,
    scheduledDate,
    address,
    leaseEndDate,
    templateType,
  });
};



export async function saveWebhook(
  webhookId: string, url : string, secret_toekn : string, eventPayload: string  
): Promise<string | null> {  
  return saveWebhookImp(webhookId, url, secret_toekn, eventPayload)
}

export async function getWebhook(
  id : string
): Promise<TaskWebhook | null> {
  return getWebhookImp(id)
}

export async function deleteWebhook(id: string) : Promise<void> {
  await deleteWebhookImp(id);
}

export async function getWebhooks() : Promise<TaskWebhook[]> {
  return await getWebhooksImp() ?? [];
}

export async function createTaskNotificationRequest(request : Omit<TaskNotificationRequest,'id'>) : Promise<string | null> {
  return await createTaskNotificationRequestImp(request);
}

export async function deleteTaskNotificationRequest(id : string) : Promise<void> {
  await deleteWebhookImp(id);
}

export async function getTaskNotificationRequestByTaskId(taskId : string) : Promise<TaskNotificationRequest[]> {
  return await getTaskNotificationRequestByTaskIdImp(taskId);
}

export async function getTaskNotificationRequest(id: string) : Promise<TaskNotificationRequest | null> {
  return await getTaskNotificationRequestImp(id);
}

// feed events
export async function saveFeedEvent(
  feedEvent: FeedEvent
): Promise<string | null> {
  return saveFeedEventImp(feedEvent);
}

export async function getFeedEvent(id: string): Promise<FeedEvent | null> {
  return getFeedEventImp(id);
}

export async function deleteFeedEvent(id: string): Promise<void> {
  return deleteFeedEventImp(id);
}


type FeedEventFilter = {
  processId?: string,
  projectId?: string,
  buildingId? : number,
  unitId? : string,
  userId? : string,
  createdOn?: Date,
  createdAfter?: Date,
  createdBefore?: Date,
  /**
   * Restrict to specific event types (Firestore `in`, max 30 values). Use this
   * to pull a project's `state_*` status events without dragging in its whole
   * feed — see `STATUS_EVENT_TYPES` in `@/helpers/unitStatus`.
   *
   * Combining this with `projectId` needs the composite index declared in
   * firestore.indexes.json. Note the Firestore collection is `feed`, not
   * `feedEvents` — that's only the client-side alias (see firebase.ts).
   */
  eventTypes?: string[],
};

function feedEventFiltersImp(filter: FeedEventFilter): QueryFieldFilterConstraint[] {
  const { createdOn, createdAfter, createdBefore, processId, eventTypes } = filter;

  let filters : QueryFieldFilterConstraint[] = [];

  if (processId) {
    filters.push(where('processId', '==', processId));
  }

  if (eventTypes && eventTypes.length > 0) {
    filters.push(where('eventType', 'in', eventTypes));
  }

  if (createdOn) {
    filters.push(where('eventDate', '==', createdOn));
  }

  if (createdAfter) {
    filters.push(where('eventDate', '>', createdAfter));
  }

  if (createdBefore) {
    filters.push(where('eventDate', '<', createdBefore));
  }

  return filters;
}

export async function getFeedEvents(filter? : FeedEventFilter): Promise<FeedEvent[]> {
  const { projectId, buildingId, unitId, userId } = filter || {};

  const filters = feedEventFiltersImp(filter || {});

  return getItemsImp(feedEventsQueryImp(projectId, buildingId, unitId, userId,...filters));
}


export async function subscribeToFeedEvents(
  filter: FeedEventFilter,
  onUpdate: (items: FeedEvent[]) => void,
  onError: (error: Error) => void
): Promise<() => void> {
  const { projectId, buildingId, unitId, userId } = filter;

  const filters = feedEventFiltersImp(filter);

  return subscribeToImp(feedEventsQueryImp(projectId, buildingId, unitId, userId,...filters), onUpdate, onError);
}

export async function getBuildingWorkflows(
  projectId: string,
): Promise<BuildingWorkflow[]> {  
  return getBuildingWorkflowsImp(projectId);
}


export async function saveProcess(
  process: Process
): Promise<string | null> {
  return saveGenericObjectmImp('processes',process);
}

export async function getProcess(id: string): Promise<Process | null> {
  return getGenericObjectImp('processes',id);
}

export const deleteProcess = async (
  processId: string,
): Promise<boolean> => {
  return deleteGenericObjImp('processes',processId);
};


export async function getProcesses(filter? : {
  processId?: string,
  projectId?: string,
  buildingId? : number,
  unitId? : string,
  userId? : string,
  createdAfter?: Date,
  createdBefore?: Date}, onUpdate?: (items: Process[]) => void,
  ): Promise<Process[] | (() => void)> {

  const { projectId, buildingId, unitId, userId,createdAfter,createdBefore } = filter || {};

  let filters : QueryFieldFilterConstraint[] = [];

  if (createdAfter) {
    filters.push(where('startedAt', '>', createdAfter));
  }

  if (createdBefore) {
    filters.push(where('startedAt', '<', createdBefore));
  }
  if (onUpdate) {
    return subscribeToImp(
      genericQueryImp(getDatabase().processes,{ projectId, buildingId, unitId, userId},filters),
      onUpdate,
      (error) => {
        console.error('error getting documents',error);
        // if (reportAppError) reportAppError(error, 'Error getting documents');
      }
    );
  }

  return getItemsImp(
    genericQueryImp(getDatabase().processes,{ projectId, buildingId, unitId, userId},filters)
  )
}

// Lease operations
export async function saveLease(lease: Lease): Promise<string | null> {
  return saveGenericObjectmImp('leases', lease);
}

export async function getLease(id: string): Promise<Lease | null> {
  return getGenericObjectImp('leases', id);
}

export async function deleteLease(leaseId: string): Promise<boolean> {
  return deleteGenericObjImp('leases', leaseId);
}

export async function getLeasesByUnitId(
  projectId: string,
  unitId: string
): Promise<Lease[]> {
  return getLeasesByUnitIdImp(projectId, unitId);
}

export async function getCurrentLease(
  projectId: string,
  unitId: string
): Promise<Lease | null> {
  return getCurrentLeaseImp(projectId, unitId);
}

export async function getLeases(
  filter?: {
    projectId?: string;
    buildingId?: number;
    unitId?: string;
    status?: 'valid' | 'canceled' | 'draft' | 'proposed';
    leaseStartAfter?: string;
    leaseStartBefore?: string;
    leaseEndAfter?: string;
    leaseEndBefore?: string;
    source?: string;
  },
  onUpdate?: (items: Lease[]) => void
): Promise<Lease[] | (() => void)> {
  return getLeasesImp(filter, onUpdate);
}
